export default __webpack_public_path__ + "static/media/PodiumPurple.afaab3af.png";